import { onMounted, onUnmounted } from 'vue'

/**
 * 测试动作桥接（仅开发态生效）
 *
 * 页面通过 testSetAction 注册具名动作，截图脚本经 window.__test.callAction 触发，
 * 用于在截图前打开弹窗、切换状态等。生产构建不注入 window.__test，注册逻辑亦无副作用。
 */

type TestActionHandler = (arg?: unknown) => unknown | Promise<unknown>

const registry = new Map<string, TestActionHandler>()

export function testSetAction(name: string, handler: TestActionHandler): void {
  registry.set(name, handler)
}

export function testUnsetAction(name: string): void {
  registry.delete(name)
}

export function listTestActions(): string[] {
  return Array.from(registry.keys())
}

export async function callTestAction(name: string, arg?: unknown): Promise<unknown> {
  const handler = registry.get(name)
  if (!handler) throw new Error(`[test] 未注册的 action: ${name}`)
  return await handler(arg)
}

/** 在组件挂载时批量注册动作，卸载时自动清理 */
export function useTestActions(actions: Record<string, TestActionHandler>): void {
  const names = Object.keys(actions)
  onMounted(() => {
    for (const name of names) testSetAction(name, actions[name])
  })
  onUnmounted(() => {
    for (const name of names) testUnsetAction(name)
  })
}

/** 仅开发态将动作注册表挂到 window.__test，供截图脚本调用 */
export function installTestBridge(): void {
  if (!import.meta.env.DEV) return
  ;(window as unknown as Record<string, unknown>).__test = {
    listActions: listTestActions,
    callAction: callTestAction,
  }
}
